export const SUPPORT_CATEGORY = { technique: "Problème technique", compte: "Compte", qrcode: "QR code", feedback: "Feedback", abonnement: "Abonnement",
  facture: "Facture", paiement: "Paiement", information: "Demande d'information", autre: "Autre" };

export const SUPPORT_PRIORITY = { low: "Basse", normal: "Normale", high: "Haute", urgent: "Urgente" };
export const PRIORITY_CLS = { low: "bg-slate-100 text-slate-600", normal: "bg-blue-50 text-blue-700", high: "bg-amber-50 text-amber-800", urgent: "bg-rose-100 text-rose-800" };

export const SUPPORT_STATUS = {
  new: { label: "Nouveau", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  assigned: { label: "Attribué", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  in_progress: { label: "En cours", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  waiting_customer: { label: "En attente du client", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  resolved: { label: "Résolu", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  closed: { label: "Clôturé", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const fmtHours = (h) => (h === null || h === undefined ? "—" : h < 48 ? `${h} h` : `${Math.round(h / 24)} j`);
